import type { UUID } from './identifier';

export interface Fleet {
  id: UUID;
  name: string;
  active: boolean;
}

export interface FuscaFleetShippingInfo {
  address: string;
  contactEmail: string;
  contactPhone: string;
}

export enum FuscaFleetAddressType {
  SHIPPING = 'SHIPPING',
}

export interface FuscaFleetAddress {
  id?: UUID;
  addressType: FuscaFleetAddressType;
  zipCode: string;
  city: string;
  uf: string;
  neighborhood: string;
  street: string;
  number?: string;
  complement?: string;
  phone: string;
  email: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface FuscaFleetInfo {
  id: UUID;
  name: string;
  shipping: FuscaFleetShippingInfo;
  addresses: FuscaFleetAddress[];
}

export enum HiredProduct {
  TELEMETRY = 'telemetry',
  CAM = 'cam',
  CAM_PRO = 'cam_pro',
}
